import { newApiReadOnly } from '@lune/auth/api/fetch'
import { apiUrlCollectionFactory, type ApiKindAndUrl } from '@lune/common/api'
import { LoginPage, Root } from '../paths'
import { idToString, type Config } from './types'
import { version } from './version'

if (process.env.NOBODY === undefined) {
  console.error('process.env.NOBODY is not defined')
}

export const DEFAULT_CONFIG = 'default'

export const NOBODY_LIST: string[] =
  process.env.NOBODY !== undefined ? [process.env.NOBODY] : []

export const collectionApi = apiUrlCollectionFactory(
  version,
  Root,
  idToString,
  `/config`
)

export const ConfigApiUrl = (): { config: ApiKindAndUrl<Config, string> } => ({
  config: {
    kind: '#config',
    api: collectionApi
  }
})

export const api = newApiReadOnly<Config, string>(
  ConfigApiUrl().config,
  LoginPage
)
